import { useCallback } from 'react'

import { useActivateAutomationVersion } from '../useActivateAutomationVersion'
import { useSaveAutomationVersion } from '../useSaveAutomationVersion'

export const useSaveAndActivateAutomationVersion = () => {
  const saveAutomationVersion = useSaveAutomationVersion()
  const activateAutomationVersion = useActivateAutomationVersion()

  return useCallback(
    async ({ changelog }: { changelog: string | undefined }): Promise<void> => {
      // Both hooks throw on failure, which propagates to the publish flow's
      // catch — no per-step handling needed here.
      const saved = await saveAutomationVersion({ changelog })
      await activateAutomationVersion(saved)
    },
    [saveAutomationVersion, activateAutomationVersion]
  )
}
